import EmblaCarousel, { EmblaOptionsType } from 'embla-carousel';
import { addDotBtnsAndClickHandlers } from './EmblaCarouselDotButtons';

const interactiveMap = (): void => {
  const classes = {
    markerActive: 'interactive-map__marker--active',
    mobileCardsActive: 'interactive-map__mobile-cards--active',
  };

  const selectors = {
    interactiveMap: '[data-interactive-map]',
    interactiveMapVisibleMarker: 'data-visible-marker',
    interactiveMapMarker: '[data-map-marker]',
    interactiveMapMarkerToggle: '[data-map-marker-toggle]',
    interactiveMapMarkerToggleAttr: 'data-map-marker-toggle',
    interactiveMapMarkerClose: '[data-map-marker-close]',
    interactiveMapMobileCardClose: '[data-interactive-map-mobile-card-close]',
  };

  const hoverListSections = document.querySelectorAll(selectors.interactiveMap);

  hoverListSections.forEach((section) => {
    const mapMarkers = section.querySelectorAll(selectors.interactiveMapMarker);

    const mobileCloseButtons = section.querySelectorAll(
      selectors.interactiveMapMobileCardClose
    );

    if (mapMarkers) {
      mapMarkers.forEach((marker) => {
        const markerToggle = marker.querySelector(
          selectors.interactiveMapMarkerToggle
        );

        const markerClose = marker.querySelector(
          selectors.interactiveMapMarkerClose
        );

        if (markerToggle) {
          markerToggle.addEventListener('click', () => {
            const markerID = markerToggle.getAttribute(
              selectors.interactiveMapMarkerToggleAttr
            );

            if (marker.classList.contains(classes.markerActive)) {
              marker.classList.remove(classes.markerActive);
              section.setAttribute(selectors.interactiveMapVisibleMarker, '');
            } else {
              mapMarkers.forEach((otherMarker) => {
                otherMarker.classList.remove(classes.markerActive);
              });
              marker.classList.add(classes.markerActive);
              section.setAttribute(
                selectors.interactiveMapVisibleMarker,
                markerID
              );
            }
          });

          markerToggle.addEventListener('mouseenter', () => {
            const markerID = markerToggle.getAttribute(
              selectors.interactiveMapMarkerToggleAttr
            );

            mapMarkers.forEach((otherMarker) => {
              otherMarker.classList.remove(classes.markerActive);
            });
            marker.classList.add(classes.markerActive);
            section.setAttribute(
              selectors.interactiveMapVisibleMarker,
              markerID
            );
          });
        }

        if (markerClose) {
          markerClose.addEventListener('click', () => {
            marker.classList.remove(classes.markerActive);
            section.setAttribute(selectors.interactiveMapVisibleMarker, '');
          });
        }
      });
    }

    if (mobileCloseButtons) {
      mobileCloseButtons.forEach((button) => {
        button.addEventListener('click', () => {
          section.setAttribute(selectors.interactiveMapVisibleMarker, '');

          if (mapMarkers) {
            mapMarkers.forEach((marker) => {
              marker.classList.remove(classes.markerActive);
            });
          }
        });
      });
    }

    const mobileCarousels = section.querySelectorAll(
      '[data-interactive-map-mobile-carousel]'
    );

    if (mobileCarousels) {
      mobileCarousels.forEach((carousel) => {
        const viewportNode: HTMLDivElement = carousel.querySelector(
          '[data-interactive-map-mobile-carousel-viewport]'
        );

        const dotsNode: HTMLDivElement = carousel.querySelector(
          '[data-interactive-map-mobile-carousel-dots]'
        );

        const options: EmblaOptionsType = {
          loop: false,
          align: 'start',
        };

        const embla = EmblaCarousel(viewportNode, options);

        const removeDotBtnsAndClickHandlers = addDotBtnsAndClickHandlers(
          embla,
          dotsNode
        );
      });
    }
  });
};

export default interactiveMap;
